/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbSharedRefineMenuPriceRanges_user$ref = any;
export type SbSharedRefineMenuPriceRanges_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly " $refType": SbSharedRefineMenuPriceRanges_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedRefineMenuPriceRanges_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isVerifiedTrade",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = '5f28254e4fdc4994adaee2f3f6380047';
export default node;
